<template>
  <span class="calc-label">
    <span v-if="prefix" class="calc-label__prefix">{{ prefix }}</span>
    <b v-if="short && !plain">{{ short }}</b>
    <span v-else-if="short">{{ short }}</span>
    <span v-if="name">{{ short ? ` (${name})` : name }}</span>
    <small v-if="extra" class="calc-label__extra">({{ extra }})</small>
    <help-tip v-if="tip" :text="tip"></help-tip>
  </span>
</template>

<script>
import HelpTip from "@/components/HelpTip.vue";

/** Zeilenbeschriftung der Kalkulation wie in der Kalkulationstabelle: "+ BEP (Bezugspreis) (Zusatz)" mit fettem Kuerzel. */
export default {
  name: "CalcLabel",
  components: { HelpTip },
  props: {
    /** "+", "=", "–" oder leer */
    prefix: { type: String, default: "" },
    /** Kuerzel, fett (z. B. BEP) */
    short: { type: String, default: "" },
    /** Langname, mit Kuerzel in Klammern */
    name: { type: String, default: "" },
    /** Zusatz in kleiner Schrift, in Klammern (z. B. Umrechnungskurs) */
    extra: { type: String, default: "" },
    /** Kuerzel nicht fett (Zwischenzeilen wie "= EK" und "+ BZNK") */
    plain: { type: Boolean, default: false },
    tip: { type: String, default: "" },
  },
};
</script>

<style scoped>
.calc-label__prefix {
  display: inline-block;
  min-width: 12px;
}
.calc-label__extra {
  color: #777;
  font-size: 11px;
  margin-left: 3px;
}
.calc-label .help-tip {
  margin-left: 4px;
}
</style>
